import React, { useEffect, useState } from "react";
import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Cookies from "js-cookie";

import { darkTheme, lightTheme } from "./theme";
import Navbar from "./components/main/Navbar";
import Footer from "./components/main/Footer";
import NotFound from "./pages/404";

import Main from "./pages/Main";
import Work from "./pages/Work";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Technologies from "./pages/Technologies";
import Experience from "./pages/Experience";
import Contact from "./pages/Contact";
import WebPort from "./pages/portfolios/WebPort";
import ThreeDPort from "./pages/portfolios/3dPort";
import GameplayPort from "./pages/portfolios/GameplayPort";
import UiPort from "./pages/portfolios/UiPort";

const THEME_COOKIE_KEY = "themePreference_fdf5e9";

function App() {
  const [isDarkTheme, setIsDarkTheme] = useState(true);

  useEffect(() => {
    const cookieValue = Cookies.get(THEME_COOKIE_KEY);
    if (cookieValue) {
      setIsDarkTheme(cookieValue === "dark");
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDarkTheme;
    setIsDarkTheme(newTheme);
    Cookies.set(THEME_COOKIE_KEY, newTheme ? "dark" : "light", {
      expires: 365,
    });
  };

  return (
    <ThemeProvider theme={isDarkTheme ? darkTheme : lightTheme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <Box component="main">
          <Routes>
            <Route path="/" element={<Main />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/work" element={<Work />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/technologies" element={<Technologies />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/p/web" element={<WebPort />} />
            <Route path="/p/gameplay" element={<GameplayPort />} />
            <Route path="/p/3d" element={<ThreeDPort />} />
            <Route path="/p/ui" element={<UiPort />} />
          </Routes>
        </Box>
        <Footer onToggleTheme={toggleTheme} isDarkTheme={isDarkTheme} />
      </Router>
    </ThemeProvider>
  );
}

export default App;
